import React from 'react';
import { Button, HStack } from '@chakra-ui/react';
import { FiExternalLink, FiMaximize2 } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';

// item 400 — THE chat control pair, rendered in each chat surface's HEADER row (next
// to its Slack settings) so every chat carries identical controls on one line — the
// panel itself stays pure chat.
const ChatFocusControls: React.FC<{ threadKey?: string; title: string }> = ({ threadKey, title }) => {
  const history = useHistory();
  const focusUrl = `/chat?threadKey=${encodeURIComponent(threadKey ?? 'accountant')}&title=${encodeURIComponent(title)}`;
  return (
    <HStack spacing={1}>
      <Button size="xs" variant="outline" leftIcon={<FiMaximize2 />} onClick={() => history.push(focusUrl)}>
        Focus
      </Button>
      <Button
        size="xs"
        variant="outline"
        leftIcon={<FiExternalLink />}
        onClick={() => window.open(focusUrl, `basixChat-${threadKey ?? 'accountant'}`, 'popup=yes,width=720,height=820')}
      >
        Undock
      </Button>
    </HStack>
  );
};

ChatFocusControls.defaultProps = { threadKey: undefined };

export default ChatFocusControls;
